import axiosClient from './axiosService';

const BASE_URL = '/coordinators';

export const getAllCoordinators = () =>
    axiosClient.get(BASE_URL);

export const getCoordinatorById = (id) =>
    axiosClient.get(`${BASE_URL}/${id}`);

export const getCoordinatorByEmail = (email) =>
    axiosClient.get(`${BASE_URL}/email`, {
        params: { email },
    });

export const createCoordinator = (coordinator) =>
    axiosClient.post(BASE_URL, coordinator);

export const getTotalCoordinatorCount = () =>
    axiosClient.get(`${BASE_URL}/count`);

export const updateCoordinator = (id, coordinator) =>
    axiosClient.put(`${BASE_URL}/${id}`, coordinator);

export const updateCoordinatorStatus = (id, coordinatorStatus) =>
    axiosClient.patch(`${BASE_URL}/${id}/status`, null, {
        params: { coordinatorStatus },
    });

export const deleteCoordinator = (id) =>
    axiosClient.delete(`${BASE_URL}/${id}`);
